// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-via6 -> weidner-apartment-homes-via6 -> the-majestic
// Generated: 2026-10-29T23:20:12.503Z
// Counts: 1 design, 20 content, 3 slot group, 1 collection binding, 8 section, 0 style

export const designOverrides = {
  "design._site.color.accent": {
    "cssVariable": "--vibe-color-accent",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  }
};

export const contentOverrides = {
  "faq-intro.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Answers to your questions</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=160/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiesgrid.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "apartment-sync-loader.inject_dni_classes": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "right-middle",
    "generatedValue": null,
    "mappedField": null
  },
  "dividerbg.tagline": {
    "overrideType": "VALUE",
    "customValue": "<p>Live your best life at The Majestic.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-intro.description": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Majestic in Wenatchee, WA, elevate your lifestyle with our diverse floor plans—cozy studios, spacious two-bedroom apartments, and penthouse living. Unwind in our state-of-the-art fitness center, socialize in the grand club room, or soak up the views from the rooftop deck. Dive into your perfect living experience today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiesgrid.amenity_7_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Walkable Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "homemap.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to The Majestic, your serene sanctuary in Wenatchee, WA. Here, vibrant community life meets nature's beauty, with nearby gems like Wenatchee Riverfront Park, Ohme Gardens, and the scenic Apple Capital Recreational Loop Trail. Engage with local culture at the Numerica Performing Arts Center, all just steps from your front door.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemapsection.map_block": {
    "overrideType": "VALUE",
    "customValue": "engrain-sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemapsection.map.height": {
    "overrideType": "VALUE",
    "customValue": "750",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemapsection.map.javascript_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_engrain_sightmap_url"
  },
  "interactivemapsection.map.sitemap_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_engrain_sightmap_url"
  },
  "pet-policy-intro-secondary.description": {
    "overrideType": "VALUE",
    "customValue": "<p>From shaded walking paths to nearby green spaces, our community was designed with four-legged residents in mind. Bring your furry family member home and discover all the ways we make life better — for them and for you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>The Majestic brings the best of Wenatchee to your doorstep. Nestled in the heart of Wenatchee, you'll live within walking distance of the area's best restaurants, retailers, natural attractions, and entertainment offerings. Pre-lease your new apartment at The Majestic for Summer 2027!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e3be9-997a-71cc-bbc1-54ab2125b397.webp"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Contact Us"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "gallerytabs.apartment_images": {
    "limit": null,
    "hiddenIds": [
      "custom_bd8415e8-1878-4695-bbb0-c1f19e52390a",
      "custom_60e652d4-0c13-4602-b339-93b651a11fff"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      4,
      2
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
